module.exports = __webpack_public_path__ + "dist/assets/img/bige-icon-account.013b70c4.svg";